import { TimingOptionsType } from "../mp-database"

export enum ManagePages {
  Districts = "Districts",
  DistrictAdmins = "District Admins",
  Schools = "Schools",
  SchoolAdmins = "School Admins",
  Teachers = "Teachers",
  Classes = "Classes",
  Students = "Students"
}

export enum ManageType {
  add = "add",
  edit = "edit"
}

export enum AccountMode {
  email = "email",
  username = "username"
}

export enum PasswordMode {
  manual = "manual",
  invite = "invite"
}

export type UserFormData = {
  firstName: string
  lastName: string
  accountMode?: string
  email: string
  username: string
  title?: string
  isTeacher?: boolean
  sfid?: string
  passwordMode?: string
  resetPasswordMode?: ResetPasswordMode
  password?: string
  timeAccomodation?: TimingOptionsType
}

export enum ResetPasswordMode {
  reset = "reset",
  request = "request"
}

export enum TimingAccommodationsMode {
  // NOTE: 'noTimingAccomdations' is intentionally misspelled with single 'm'
  // to maintain compatibility with existing Firebase field values
  noTiming = "noTimingAccomdations",
  unlimitedTime = "unlimitedTime",
  doubleTime = "doubleTime",
  timeAndHalf = "timeAndHalf",
  customTime = "customTime"
}

export type ManageFormData = {
  [key: string]: any
}

export interface Columns {
  label: string
  sortId: string
}

export enum SortTypes {
  asc = "asc",
  desc = "desc"
}

export type ValidationResult = {
  row: string | number
  errors: string[]
}

export type UploadRecord = {
  firstName: string
  lastName: string
  username?: string
  password?: string
  email?: string
  externalStudentId?: string
  sendInvite: "no" | "yes"
}

export type UploadFormData = {
  file: File[]
  data: UploadRecord[]
}

export enum ImportableCollection {
  students = "students"
}

export type ImportParams = {
  districtId: string
  schoolId: string
  state: string
}

export type ImportCallbacks = {
  onProgress: (count: number, progress: number, record?: UploadRecord) => void
  onError: (errors: ValidationResult[], duplicates: any[]) => void
  onComplete: () => void
}

export type GenerateFormData = {
  includeDuplicates: boolean
}

export interface EducatorManageForm {
  firstName: string
  lastName: string
  email?: string
  title?: string
  isTeacher?: boolean
  sfid?: string
  password?: string
  username?: string
  manualPassword?: boolean
  overridePassword?: boolean
}

export type LoadingState = {
  data: boolean
  add: boolean
  edit: boolean
  remove: boolean
  restore: boolean
  resendInvite: boolean
  sendResetRequest: boolean
  download: boolean
  import: boolean
  assignStudents: boolean
}

export type LoadingErrorHandler = (
  message: keyof LoadingState,
  error?: Error
) => void

export type PasswordResetFormData = {
  password: string
}

export type FiltersState = {
  state?: string
  districtId?: string
  schoolId?: string
  teacherId?: string
  classId?: string
  hasRequired: boolean
}

export type AssessmentSetData = {
  testName: string
  testCategory: string
  assessmentId: string
}

export type AssessmentSetsCategories = Record<string, AssessmentSetData[]>
